module.exports = __webpack_public_path__ + "media/images/flags/1x1/bvt-564c907a8e54f105593601c704622b62.svg";